import * as React from "react";

import { Button, type ButtonProps } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export type ButtonWithIconProps = Omit<ButtonProps, "children"> & {
  label: React.ReactNode;
  icon?: React.ReactNode;
  labelClassName?: string;
};

/** Matches inset breadcrumb toolbar button sizing (`ButtonWithIcon` / header actions). */
export const DASHBOARD_TOOLBAR_BUTTON_CLASS = "h-8 shrink-0 px-3";

/** shadcn “Button with icon” — icon + label inside `Button` (see ui.shadcn.com/docs/components/button). */
export function ButtonWithIcon({
  label,
  icon,
  className,
  labelClassName,
  size = "sm",
  ...props
}: ButtonWithIconProps): React.ReactElement {
  return (
    <Button
      size={size}
      data-font="primary"
      className={cn(DASHBOARD_TOOLBAR_BUTTON_CLASS, className)}
      {...props}
    >
      {icon}
      {typeof label === "string" ? (
        <span className={cn("normal-case tracking-normal", labelClassName)}>{label}</span>
      ) : (
        label
      )}
    </Button>
  );
}
